import bitbucket from './bitbucket-cv.png';
import facebook from './facebook-cv.png';
import github from './github-cv.png';
import instagram from './instagram-cv.png';
import location from './location-cv.png';
import mail from './mail-cv.png';
import phone from './phone-cv.png';
import logo from './logo-red.png';
import footer from './logo-white.png';
import skype from './skype-cv.png';
import twitter from './twitter-cv.png';
import telegram from './telegram-cv.png';
import VK from './vk-cv.png';
import logoVention from './logoVention-black.png';
import { AttachmentEntityInterface } from '@types';
import { AttachmentFormats } from '@enums';

const imageData = {
  contentType: 'image/png',
  inline: true,
};

const links = [
  { name: 'bitBucket.png', data: bitbucket.slice(22) },
  { name: 'facebook.png', data: facebook.slice(22) },
  { name: 'github.png', data: github.slice(22) },
  { name: 'instagram.png', data: instagram.slice(22) },
  { name: 'twitter.png', data: twitter.slice(22) },
  { name: 'vk.png', data: VK.slice(22) },
  { name: 'telegram.png', data: telegram.slice(22) },
];

const imagesWithContacts = [
  { name: 'room.png', data: location.slice(22) },
  { name: 'email.png', data: mail.slice(22) },
  { name: 'phone.png', data: phone.slice(22) },
  { name: 'logo.png', data: logo.slice(22) },
  { name: 'footer.png', data: footer.slice(22) },
  { name: 'skype.png', data: skype.slice(22) },
  { name: 'logoVention-black.png', data: logoVention.slice(22) },
];

export const answerAttachments: AttachmentEntityInterface[] = [...imagesWithContacts, ...links].map(
  (image) => {
    return {
      name: image.name,
      format: AttachmentFormats.PNG,
      data: {
        name: image.name,
        data: image.data,
        contentID: image.name,
        ...imageData,
      },
    };
  }
);
